import { ArrowRight } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { trackClickCTA } from "../lib/pixel";
import { Reveal } from "./Reveal";
import { PromoCode } from "./PromoCode";
import { FB_REVIEWS_URL, REGULAMIN_URL } from "../config/site";
import { usePresaleCountdown } from "../lib/presale";

export const FinalCta = () => {
    const { ended, lastDay, promoActive, promoTime } = usePresaleCountdown();

    return (
    <>
        <section
            data-testid="final-cta-section"
            className="relative py-24 sm:py-32 bg-ink text-white overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-25"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 20% 30%, rgba(247,238,78,0.45) 0%, transparent 40%), radial-gradient(circle at 80% 70%, rgba(155,235,228,0.4) 0%, transparent 40%)",
                }}
            />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                <Reveal>
                    <p
                        data-testid="final-cta-deadline"
                        className="font-display uppercase font-extrabold tracking-tight leading-[1.04] text-4xl sm:text-6xl lg:text-7xl mb-14"
                    >
                        {ended ? (
                            <span className="inline-block bg-presale text-white px-4 sm:px-6 rounded-2xl">
                                Early Bird zakończony
                            </span>
                        ) : promoActive ? (
                            <>
                                {promoTime.lastDay ? "Tylko dziś!" : "Tylko 27 października:"}{" "}
                                <span className="inline-block bg-presale text-white px-4 sm:px-6 rounded-2xl -rotate-1 mt-3 sm:mt-4">
                                    -50 zł z kodem <PromoCode />
                                    {promoTime.lastDay && " do północy"}
                                </span>
                            </>
                        ) : lastDay ? (
                            <>
                                Ostatni dzień Early Bird!
                                <span className="inline-block bg-presale text-white px-4 sm:px-6 rounded-2xl -rotate-1 mt-3 sm:mt-4">
                                    Koniec dziś o północy
                                </span>
                            </>
                        ) : (
                            <>
                                Koniec Early Bird:{" "}
                                <span className="inline-block bg-presale text-white px-4 sm:px-6 rounded-2xl -rotate-1 mt-3 sm:mt-4">
                                    30 października o północy
                                </span>
                            </>
                        )}
                    </p>
                </Reveal>
                <Reveal>
                    <h2 className="font-display uppercase text-3xl sm:text-5xl font-extrabold tracking-tight text-balance leading-[1.15]">
                        Następnym razem nie musisz zastanawiać się:{" "}
                        <span className="inline-block bg-tang text-ink px-3 sm:px-4 rounded-xl -rotate-1 mt-2">
                            „Co ja mam teraz zrobić?”
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-8 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
                        Wybierz swój pakiet i zyskaj dostęp do konkretnych rozwiązań przygotowanych
                        z myślą o realnych lekcjach z dorosłymi.
                    </p>
                </Reveal>
                <Reveal delay={0.22}>
                    <button
                        data-testid="final-cta-button"
                        onClick={() => {
                            trackClickCTA("final-cta");
                            scrollToId("#pakiety");
                        }}
                        className="mt-10 inline-flex items-center gap-2 rounded-full bg-tang hover:bg-white text-ink font-bold uppercase tracking-wide px-8 min-h-[56px] text-sm transition-all duration-300 hover:-translate-y-0.5 shadow-lg"
                    >
                        Wybieram swój pakiet
                        <ArrowRight className="w-5 h-5" />
                    </button>
                </Reveal>
            </div>
        </section>

        <footer data-testid="site-footer" className="bg-ink text-white/70 py-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <img
                        src="/images/logo.svg"
                        alt="EduNation"
                        className="h-6 w-auto brightness-0 invert"
                    />
                </div>
                <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" aria-label="Stopka">
                    <a
                        href="https://edunation.com.pl/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                    >
                        edunation.com.pl
                    </a>
                    <a
                        href={FB_REVIEWS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                    >
                        Facebook
                    </a>
                    <a
                        href={REGULAMIN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                    >
                        Regulamin
                    </a>
                </nav>
                <p className="text-xs">© 2026 EduNation. Wszystkie prawa zastrzeżone.</p>
            </div>
        </footer>
    </>
    );
};
